import { render, staticRenderFns } from "./typ.vue?vue&type=template&id=00396e93&scoped=true&"
import script from "./typ.vue?vue&type=script&lang=ts&"
export * from "./typ.vue?vue&type=script&lang=ts&"
import style0 from "./typ.vue?vue&type=style&index=0&id=00396e93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00396e93",
  null
  
)

export default component.exports